// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Moment = require("moment");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Js_promise = require("rescript/lib/js/js_promise.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var ReactDates = require("react-dates");
var JsxRuntime = require("react/jsx-runtime");
var Http$ReactHooksTemplate = require("../common/http.res.js");
var Image$ReactHooksTemplate = require("../common/image.res.js");
var Utils$ReactHooksTemplate = require("../common/utils.res.js");
var ApiKey$ReactHooksTemplate = require("../settings/apiKey.res.js");
var AlertComponent$ReactHooksTemplate = require("../common/AlertComponent.res.js");

function Api(props) {
  var initialState_newKey = ApiKey$ReactHooksTemplate.empty();
  var initialState = {
    apiKeys: /* [] */0,
    focused: false,
    keyForm: false,
    newKey: initialState_newKey,
    notification: undefined,
    show: undefined
  };
  var match = React.useState(function (param) {
        return initialState;
      });
  var setState = match[1];
  var state = match[0];
  React.useEffect((function (param) {
          Js_promise.then_((function (apiKeys) {
                  return Promise.resolve(Curry._1(setState, (function (state) {
                                    return {
                                            apiKeys: apiKeys,
                                            focused: state.focused,
                                            keyForm: state.keyForm,
                                            newKey: state.newKey,
                                            notification: state.notification,
                                            show: state.show
                                          };
                                  })));
                }), Http$ReactHooksTemplate.fetchGetJSONDecode("/api_keys", (function (param) {
                      return Json_decode.field("api_keys", (function (param) {
                                    return Json_decode.list(ApiKey$ReactHooksTemplate.decode, param);
                                  }), param);
                    })));
        }), []);
  var handleAlert = function (alertType) {
    Curry._1(setState, (function (state) {
            return {
                    apiKeys: state.apiKeys,
                    focused: state.focused,
                    keyForm: state.keyForm,
                    newKey: state.newKey,
                    notification: alertType,
                    show: state.show
                  };
          }));
  };
  var handleSaveForm = function (apiKey) {
    var id = ApiKey$ReactHooksTemplate.id(apiKey);
    var encodedkey = ApiKey$ReactHooksTemplate.encode(apiKey);
    var params = {};
    params["api_key"] = encodedkey;
    if (id !== undefined) {
      Js_promise.then_((function (response) {
              var status = Json_decode.field("status", (function (param) {
                      return Json_decode.withDefault("failure", Json_decode.string, param);
                    }), response);
              if (status === "success") {
                var apiKey = Json_decode.field("api_key", ApiKey$ReactHooksTemplate.decode, response);
                var newList = Belt_List.map(state.apiKeys, (function (key) {
                        if (Caml_obj.equal(ApiKey$ReactHooksTemplate.id(key), ApiKey$ReactHooksTemplate.id(apiKey))) {
                          return apiKey;
                        } else {
                          return key;
                        }
                      }));
                Curry._1(setState, (function (state) {
                        return {
                                apiKeys: newList,
                                focused: state.focused,
                                keyForm: false,
                                newKey: state.newKey,
                                notification: state.notification,
                                show: state.show
                              };
                      }));
                handleAlert({
                      TAG: "Success",
                      _0: "Updated Key"
                    });
              } else {
                var errorMessage = Json_decode.field("errors", (function (param) {
                        return Json_decode.array(Json_decode.string, param);
                      }), response);
                var message = Belt_List.headExn(Belt_List.fromArray(errorMessage));
                handleAlert({
                      TAG: "Failure",
                      _0: message
                    });
              }
              return Promise.resolve();
            }), Http$ReactHooksTemplate.fetchPostJSON("/api_keys/" + String(id) + "/update", params));
    } else {
      Js_promise.then_((function (response) {
              var status = Json_decode.field("status", (function (param) {
                      return Json_decode.withDefault("failure", Json_decode.string, param);
                    }), response);
              if (status === "success") {
                var apiKey = Json_decode.field("api_key", ApiKey$ReactHooksTemplate.decode, response);
                var newList = Belt_List.concat(state.apiKeys, {
                      hd: apiKey,
                      tl: /* [] */0
                    });
                Curry._1(setState, (function (state) {
                        return {
                                apiKeys: newList,
                                focused: state.focused,
                                keyForm: false,
                                newKey: state.newKey,
                                notification: state.notification,
                                show: state.show
                              };
                      }));
                handleAlert({
                      TAG: "Success",
                      _0: "Generated New Key"
                    });
              } else {
                var errorMessage = Json_decode.field("errors", (function (param) {
                        return Json_decode.array(Json_decode.string, param);
                      }), response);
                var message = Belt_List.headExn(Belt_List.fromArray(errorMessage));
                handleAlert({
                      TAG: "Failure",
                      _0: message
                    });
              }
              return Promise.resolve();
            }), Http$ReactHooksTemplate.fetchPostJSON("/api_keys", params));
    }
  };
  var handleNameInput = function ($$event) {
    var nameInput = Utils$ReactHooksTemplate.formTargetValue($$event);
    var key = ApiKey$ReactHooksTemplate.setName(state.newKey, nameInput);
    Curry._1(setState, (function (state) {
            return {
                    apiKeys: state.apiKeys,
                    focused: state.focused,
                    keyForm: state.keyForm,
                    newKey: key,
                    notification: state.notification,
                    show: state.show
                  };
          }));
  };
  var toggleKeyForm = function (param) {
    Curry._1(setState, (function (state) {
            return {
                    apiKeys: state.apiKeys,
                    focused: state.focused,
                    keyForm: !state.keyForm,
                    newKey: state.newKey,
                    notification: state.notification,
                    show: state.show
                  };
          }));
  };
  var toggleActivation = function (apiKey) {
    var revokedApiKey = ApiKey$ReactHooksTemplate.setActive(apiKey, !ApiKey$ReactHooksTemplate.active(apiKey));
    Curry._1(setState, (function (state) {
            return {
                    apiKeys: state.apiKeys,
                    focused: state.focused,
                    keyForm: state.keyForm,
                    newKey: revokedApiKey,
                    notification: state.notification,
                    show: state.show
                  };
          }));
  };
  var apiKeyForm = function (apiKey) {
    return JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsx("label", {
                                children: "Name",
                                className: "w-40 text-gray-700 font-medium mt-2"
                              }),
                          JsxRuntime.jsxs("div", {
                                children: [
                                  JsxRuntime.jsx("input", {
                                        className: "px-4 py-2 border border-gray-300 rounded-md",
                                        id: "name",
                                        placeholder: "Enter name",
                                        value: ApiKey$ReactHooksTemplate.name(apiKey),
                                        onChange: handleNameInput
                                      }),
                                  ApiKey$ReactHooksTemplate.name(state.newKey).length === 0 ? JsxRuntime.jsx("p", {
                                          children: "Name can't be empty",
                                          className: "text-red-500 text-xs mt-1"
                                        }) : JsxRuntime.jsx(JsxRuntime.Fragment, {})
                                ],
                                className: "flex flex-col w-3/10"
                              })
                        ],
                        className: "flex items-start space-x-4"
                      }),
                  JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsx("label", {
                                children: "Expiration Date",
                                className: "w-40 text-gray-700 font-medium"
                              }),
                          JsxRuntime.jsx("div", {
                                children: JsxRuntime.jsx(ReactDates.SingleDatePicker, {
                                      date: ApiKey$ReactHooksTemplate.expirationDate(apiKey),
                                      onDateChange: (function (newDate) {
                                          var key = ApiKey$ReactHooksTemplate.setExpirationDate(state.newKey, newDate);
                                          Curry._1(setState, (function (state) {
                                                  return {
                                                          apiKeys: state.apiKeys,
                                                          focused: state.focused,
                                                          keyForm: state.keyForm,
                                                          newKey: key,
                                                          notification: state.notification,
                                                          show: state.show
                                                        };
                                                }));
                                        }),
                                      focused: state.focused,
                                      onFocusChange: (function (focusInfo) {
                                          Curry._1(setState, (function (state) {
                                                  return {
                                                          apiKeys: state.apiKeys,
                                                          focused: focusInfo.focused,
                                                          keyForm: state.keyForm,
                                                          newKey: state.newKey,
                                                          notification: state.notification,
                                                          show: state.show
                                                        };
                                                }));
                                        }),
                                      id: "unique_date_picker_id",
                                      numberOfMonths: 1,
                                      displayFormat: "DD/MM/YYYY",
                                      noBorder: true,
                                      openDirection: "down",
                                      hideKeyboardShortcutsPanel: true
                                    }),
                                className: "single-picker-wrapper"
                              })
                        ],
                        className: "flex items-center space-x-4"
                      }),
                  JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsx("button", {
                                children: "Cancel",
                                className: "border border-gray-400 flex rounded py-3 px-6 text-base font-semibold justify-center",
                                id: "close_modal",
                                onClick: (function (param) {
                                    Curry._1(setState, (function (state) {
                                            return {
                                                    apiKeys: state.apiKeys,
                                                    focused: state.focused,
                                                    keyForm: false,
                                                    newKey: ApiKey$ReactHooksTemplate.empty(),
                                                    notification: state.notification,
                                                    show: state.show
                                                  };
                                          }));
                                  })
                              }),
                          JsxRuntime.jsx("button", {
                                children: "Save",
                                className: "bg-palatinateblue border border-gray-400 flex rounded\n                          py-3 px-6 text-base font-semibold text-white justify-center " + (
                                  ApiKey$ReactHooksTemplate.name(state.newKey).length === 0 ? "disabled-input" : ""
                                ),
                                disabled: ApiKey$ReactHooksTemplate.name(state.newKey).length === 0,
                                onClick: (function (param) {
                                    handleSaveForm(state.newKey);
                                  })
                              })
                        ],
                        className: "py-5 pr-8 flex border-t border-gray-200 gap-3 font-medium text-base w-full justify-end"
                      })
                ],
                className: "mb-8 space-y-4"
              });
  };
  var toggleMasking = function (index) {
    var i = state.show;
    if (i !== undefined) {
      if (i === index) {
        return Curry._1(setState, (function (state) {
                      return {
                              apiKeys: state.apiKeys,
                              focused: state.focused,
                              keyForm: state.keyForm,
                              newKey: state.newKey,
                              notification: state.notification,
                              show: undefined
                            };
                    }));
      } else {
        return Curry._1(setState, (function (state) {
                      return {
                              apiKeys: state.apiKeys,
                              focused: state.focused,
                              keyForm: state.keyForm,
                              newKey: state.newKey,
                              notification: state.notification,
                              show: index
                            };
                    }));
      }
    } else {
      return Curry._1(setState, (function (state) {
                    return {
                            apiKeys: state.apiKeys,
                            focused: state.focused,
                            keyForm: state.keyForm,
                            newKey: state.newKey,
                            notification: state.notification,
                            show: index
                          };
                  }));
    }
  };
  var today = Moment(new Date().toDateString());
  var alertType = state.notification;
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("div", {
                              children: "Api Key Management",
                              className: "text-darkcharcoal font-bold text-xl"
                            }),
                        alertType !== undefined ? JsxRuntime.jsx(AlertComponent$ReactHooksTemplate.make, {
                                alertType: alertType,
                                handleClose: (function (param) {
                                    Curry._1(setState, (function (state) {
                                            return {
                                                    apiKeys: state.apiKeys,
                                                    focused: state.focused,
                                                    keyForm: state.keyForm,
                                                    newKey: state.newKey,
                                                    notification: undefined,
                                                    show: state.show
                                                  };
                                          }));
                                  })
                              }) : JsxRuntime.jsx(JsxRuntime.Fragment, {})
                      ],
                      className: "border-b border-gray-300 px-5 py-6 flex justify-between\n                 w-full"
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx("h2", {
                                      children: state.keyForm ? "Generate New Api Key" : "Api Keys",
                                      className: "pl-3 font-bold text-base text-darkcharcoal"
                                    }),
                                state.keyForm ? JsxRuntime.jsx(JsxRuntime.Fragment, {}) : JsxRuntime.jsx("a", {
                                        children: "Add new key",
                                        className: "text-white bg-blue-600 hover:bg-blue-800 py-6-px px-20-px ml-auto",
                                        onClick: (function (param) {
                                            toggleKeyForm();
                                            var date = Moment(new Date().toDateString());
                                            var apiKey = ApiKey$ReactHooksTemplate.setExpirationDate(ApiKey$ReactHooksTemplate.empty(), Caml_option.some(date));
                                            Curry._1(setState, (function (state) {
                                                    return {
                                                            apiKeys: state.apiKeys,
                                                            focused: state.focused,
                                                            keyForm: true,
                                                            newKey: apiKey,
                                                            notification: state.notification,
                                                            show: state.show
                                                          };
                                                  }));
                                          })
                                      })
                              ],
                              className: "flex justify-between items-center mb-30-px"
                            }),
                        state.keyForm ? apiKeyForm(state.newKey) : JsxRuntime.jsxs("table", {
                                children: [
                                  JsxRuntime.jsx("thead", {
                                        children: JsxRuntime.jsxs("tr", {
                                              children: [
                                                JsxRuntime.jsx("th", {
                                                      children: "Name",
                                                      className: "text-left w-1/10 font-extralight py-10-px px-4"
                                                    }),
                                                JsxRuntime.jsx("th", {
                                                      children: "Key",
                                                      className: "text-left w-3/10 font-extralight py-10-px px-4"
                                                    }),
                                                JsxRuntime.jsx("th", {
                                                      children: "Status",
                                                      className: "text-left w-1/12 font-extralight py-10-px px-4"
                                                    }),
                                                JsxRuntime.jsx("th", {
                                                      children: "Expiration Date",
                                                      className: "text-left w-1/12 font-extralight py-10-px px-4"
                                                    }),
                                                JsxRuntime.jsx("th", {
                                                      children: "Actions",
                                                      className: "text-left w-1/10 py-10-px px-4"
                                                    })
                                              ]
                                            }),
                                        className: "border border-gray-400 bg-ghostwhite text-aurometalsaurus"
                                      }),
                                  JsxRuntime.jsx("tbody", {
                                        children: $$Array.of_list(Belt_List.mapWithIndex(state.apiKeys, (function (i, apiKey) {
                                                    var index = state.show;
                                                    var active = ApiKey$ReactHooksTemplate.active(apiKey);
                                                    var date = ApiKey$ReactHooksTemplate.expirationDate(apiKey);
                                                    return JsxRuntime.jsxs("tr", {
                                                                children: [
                                                                  JsxRuntime.jsx("td", {
                                                                        children: ApiKey$ReactHooksTemplate.name(apiKey),
                                                                        className: "p-4 border-r border-gray-300"
                                                                      }),
                                                                  JsxRuntime.jsx("td", {
                                                                        children: JsxRuntime.jsxs("div", {
                                                                              children: [
                                                                                index !== undefined ? JsxRuntime.jsxs(JsxRuntime.Fragment, {
                                                                                        children: [
                                                                                          JsxRuntime.jsx("input", {
                                                                                                className: "w-full border-none focus:outline-none",
                                                                                                type: index === i ? "text" : "password",
                                                                                                value: ApiKey$ReactHooksTemplate.key(apiKey)
                                                                                              }),
                                                                                          JsxRuntime.jsx("button", {
                                                                                                children: JsxRuntime.jsx("img", {
                                                                                                      className: "h-5 w-5 cursor-pointer",
                                                                                                      src: index === i ? Image$ReactHooksTemplate.previewEye : Image$ReactHooksTemplate.closedEye
                                                                                                    }),
                                                                                                className: "pr-2 focus:outline-none",
                                                                                                onClick: (function (param) {
                                                                                                    toggleMasking(i);
                                                                                                  })
                                                                                              })
                                                                                        ]
                                                                                      }) : JsxRuntime.jsxs(JsxRuntime.Fragment, {
                                                                                        children: [
                                                                                          JsxRuntime.jsx("input", {
                                                                                                className: "flex w-full border-none focus:outline-none\n                                       cursor-pointer",
                                                                                                type: "password",
                                                                                                value: ApiKey$ReactHooksTemplate.key(apiKey)
                                                                                              }),
                                                                                          JsxRuntime.jsx("button", {
                                                                                                children: JsxRuntime.jsx("img", {
                                                                                                      className: "h-5 w-5 cursor-pointer",
                                                                                                      src: Image$ReactHooksTemplate.closedEye
                                                                                                    }),
                                                                                                className: "pr-2 focus:outline-none",
                                                                                                onClick: (function (param) {
                                                                                                    toggleMasking(i);
                                                                                                  })
                                                                                              })
                                                                                        ]
                                                                                      }),
                                                                                JsxRuntime.jsx("button", {
                                                                                      children: JsxRuntime.jsx("img", {
                                                                                            className: "h-5 w-5 cursor-pointer",
                                                                                            src: Image$ReactHooksTemplate.copy
                                                                                          }),
                                                                                      className: "focus:outline-none",
                                                                                      onClick: (function (param) {
                                                                                          var copiedKey = ApiKey$ReactHooksTemplate.key(apiKey);
                                                                                          Js_promise.then_((function (param) {
                                                                                                  console.log("Text copied to clipboard");
                                                                                                  handleAlert({
                                                                                                        TAG: "Success",
                                                                                                        _0: "Copied Key"
                                                                                                      });
                                                                                                  return Promise.resolve();
                                                                                                }), navigator.clipboard.writeText(copiedKey));
                                                                                        })
                                                                                    })
                                                                              ],
                                                                              className: "flex"
                                                                            }),
                                                                        className: "p-4 border-r border-gray-300"
                                                                      }),
                                                                  JsxRuntime.jsx("td", {
                                                                        children: active ? "Active" : "Inactive",
                                                                        className: "p-4 border-r border-gray-300"
                                                                      }),
                                                                  JsxRuntime.jsx("td", {
                                                                        children: date !== undefined ? Caml_option.valFromOption(date).format("DD/MM/YYYY") : JsxRuntime.jsx(JsxRuntime.Fragment, {}),
                                                                        className: "p-4 border-r border-gray-300"
                                                                      }),
                                                                  JsxRuntime.jsx("td", {
                                                                        children: JsxRuntime.jsxs("div", {
                                                                              children: [
                                                                                Belt_Option.getExn(ApiKey$ReactHooksTemplate.expirationDate(apiKey)).isBefore(today) ? JsxRuntime.jsx(JsxRuntime.Fragment, {}) : JsxRuntime.jsx(JsxRuntime.Fragment, {
                                                                                        children: Caml_option.some(ApiKey$ReactHooksTemplate.active(apiKey) ? JsxRuntime.jsx("button", {
                                                                                                    children: "Revoke",
                                                                                                    className: "text-xs text-red-600 border border-red-600 focus:outline-none px-2 py-1 rounded hover:bg-red-50",
                                                                                                    onClick: (function (param) {
                                                                                                        toggleActivation(apiKey);
                                                                                                        handleSaveForm(ApiKey$ReactHooksTemplate.setActive(apiKey, !ApiKey$ReactHooksTemplate.active(apiKey)));
                                                                                                      })
                                                                                                  }) : JsxRuntime.jsx("button", {
                                                                                                    children: "Activate",
                                                                                                    className: "text-xs text-green-600 border border-green-600 focus:outline-none px-2 py-1 rounded hover:bg-green-100",
                                                                                                    onClick: (function (param) {
                                                                                                        toggleActivation(apiKey);
                                                                                                        handleSaveForm(ApiKey$ReactHooksTemplate.setActive(apiKey, !ApiKey$ReactHooksTemplate.active(apiKey)));
                                                                                                      })
                                                                                                  }))
                                                                                      }),
                                                                                JsxRuntime.jsx("button", {
                                                                                      children: JsxRuntime.jsx("img", {
                                                                                            className: "h-5 w-5 cursor-pointer",
                                                                                            src: Image$ReactHooksTemplate.trash
                                                                                          }),
                                                                                      className: "focus:outline-none",
                                                                                      onClick: (function (param) {
                                                                                          var id = Belt_Option.getExn(ApiKey$ReactHooksTemplate.id(apiKey));
                                                                                          Js_promise.then_((function (response) {
                                                                                                  var status = Json_decode.field("status", (function (param) {
                                                                                                          return Json_decode.withDefault("failure", Json_decode.string, param);
                                                                                                        }), response);
                                                                                                  if (status === "success") {
                                                                                                    var newList = Belt_List.keep(state.apiKeys, (function (x) {
                                                                                                            return Caml_obj.notequal(ApiKey$ReactHooksTemplate.id(x), ApiKey$ReactHooksTemplate.id(apiKey));
                                                                                                          }));
                                                                                                    Curry._1(setState, (function (state) {
                                                                                                            return {
                                                                                                                    apiKeys: newList,
                                                                                                                    focused: state.focused,
                                                                                                                    keyForm: state.keyForm,
                                                                                                                    newKey: state.newKey,
                                                                                                                    notification: state.notification,
                                                                                                                    show: state.show
                                                                                                                  };
                                                                                                          }));
                                                                                                  } else {
                                                                                                    console.log("failed");
                                                                                                  }
                                                                                                  return Promise.resolve();
                                                                                                }), Http$ReactHooksTemplate.fetchPostJSON("/api_keys/" + String(id) + "/delete", {}));
                                                                                        })
                                                                                    })
                                                                              ],
                                                                              className: "flex items-center space-x-4"
                                                                            }),
                                                                        className: "p-4 border-r border-gray-300"
                                                                      })
                                                                ],
                                                                className: "border-b border-gray-300"
                                                              });
                                                  }))),
                                        className: "border border-gray-400"
                                      })
                                ],
                                className: "w-full bg-white text-sm"
                              })
                      ],
                      className: "p-20-px"
                    })
              ]
            });
}

var make = Api;

exports.make = make;
/* react Not a pure module */
